//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavGridView(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M11 11H3V3H11V11ZM9 5H5V9H9V5Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M11 21H3V13H11V21ZM9 15H5V19H9V15Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M13 21H21V13H13V21ZM15 15H19V19H15V15Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M21 11H13V3H21V11ZM19 5H15V9H19V5Z" fill="currentColor" /></svg>;
}
export default IconNavGridView;